// extracted by mini-css-extract-plugin
module.exports = {"banner":"az_Y-","overrideMainBody":"az_Z-","defaultBodyText":"az__-"};